const initialState = {
  loading: false,
  vehicles: [],
  vehicle: null,
  stepCompleted: false,
}

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'GET_VEHICLES': {
      return {
        ...state,
        loading: true
      }
    }

    case 'GET_VEHICLES_COMMIT': {
      return {
        ...state,
        loading: false,
        vehicles: action.payload.vehicles
      }
    }

    case 'SET_VEHICLE': {
      return {
        ...state,
        vehicle: action.payload.vehicle,
        stepCompleted: true,
      }
    }

    default: {
      return state
    }
  }
}
